import React, { FC } from 'react'
import clsx from 'clsx'

import styles from './bottom-sheet.module.scss'
import { Spacers } from './types'

const computedStyle = window.getComputedStyle(document.documentElement)
interface BottomSheetFooterProps {
    children: React.ReactNode
    direction?: 'column' | 'row'
    pt?: Spacers
}

export const BottomSheetFooter: FC<BottomSheetFooterProps> = ({
    children,
    direction = 'row',
    pt = 'm',
}) => {
    const ptValue = computedStyle.getPropertyValue(`--spacers-${pt}`)

    return (
        <footer
            className={clsx({
                [styles[`bottom-sheet__footer`]]: true,
                [styles[`bottom-sheet__footer--direction--${direction}`]]: true,
            })}
            style={{
                paddingTop: ptValue,
            }}
        >
            {children}
        </footer>
    )
}
